import Sources from 'app/interface/redux/types/data/funnel/sources'

const Default: Sources = {
  data: [],
  loading: true,
  timestamp: +new Date(),
}

export default Default
